import PropTypes from 'prop-types';
import React from 'react';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onError: PropTypes.func,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, err: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    if (this.props.onError) this.props.onError(error, errorInfo);
  }

  get style() {
    return this.props.className
      ? {}
      : { color: '#D8000C', backgroundColor: '#FFBABA' };
  }

  render() {
    const { hasError, err } = this.state;
    return hasError ? (
      <div className={this.props.className} style={this.style}>
        <h2>Application Error</h2>
        <hr aria-hidden="true" />
        <p>
          <p>{err.toString()}</p>
          <p>{(err.stack || '').replace('at', '<br />at')}</p>
        </p>
      </div>
    ) : (
      this.props.children
    );
  }
}
